import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { telefonos} from "../../json/telefonos";
import { correos} from "../../json/telefonos";
import { buzon} from "../../json/telefonos";
import "./contacto.css";

const Contacto = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

   const linkStyle = {
    textDecoration: "none",
  };

  return (
    <>
      <div className="container convocatoria-container">
      <div className='row'>
            <div className='col_12'>
                <div className='convocatoria_title'>
                    <h1>Teléfonos/Correo de Atención</h1>
                    {/* <h2>Ventanilla Para Transformar el Campo Hidalguense</h2>
                    <h2>2024</h2> */}
                </div>
            </div>
        </div>
        <div className="row">        
        {telefonos.map((item, index) => (
          <div className="col -md-4">
            <div className="card">
              <div className="card-body">
                <h6 className=".servicios_title"> {item.area} </h6>
                <div className="btn_agenda"></div>
              </div>
            </div>
          </div>
        
         
        ))}
      </div>
      <hr></hr>
      <div className="row">        
        {correos.map((item, index) => (
          <div className="col -md-4">
            <div className="card">
              <div className="card-body">
                <h6 className=".servicios_title"> {item.area} </h6>
                <div className="btn_agenda"></div>
              </div>
            </div>
          </div>
        
         
        ))}
         <div className="container interes-container">
              <div className="row">
                <div className="col_6">
                  <div className="interes_title">
                    
                  </div>
                </div>
              </div>
              <div className="row">
                {buzon.map((item, index) => (
                  <div key={index} className="col-md-12 interes-card">
                    <Link style={linkStyle} to={item.url}>
                    <div className='interes_container'>
                            <div className='interes_icono'>
                              <img src={"/img/icons/" + item.icon }/>
                            </div>
                            <h3>{ item.nombre }</h3>
                          </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
      </div>
              

        {/* <a className='convocatoria_historicas' href="" >Consulta, Descarga y llena los Anexos requeridos para ingresar una solicitud</a> */}
      </div>
     
    </>
  );
};

export default Contacto;
